// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"329bc840","216":"bb4ae0a7","455":"505129ef","670":"d71d115f","977":"9774d471"}[chunkId] + ".chunk.js";
};